import AccommodationsContainer from './AccommodationsContainer';
export default AccommodationsContainer;
